export default {
  _not_interested_in_this_video: 'このビデオに興味がありませんか？ %second%',
  _switch_one: '取替える',
}